export const getToken = () => {
  return localStorage.getItem('OSS_Token');
};

export const getOssToken = () => {
  return getToken() ? `OSS ${getToken()}` : null;
};
